<template>
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0"> Check out Request </h6>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>
                <!-- First Name -->
                <d-col md="6" class="form-group">
                  <!-- <d-col md="4" class="form-group"> -->
                  <label for="feInputState">Capital</label>
                  <!-- <d-select :value="null" id="feInputState">
                    <d-form-select v-model="selected" :options="options" />
                  </d-select>-->
                  <select class="form-control" @change="Select()" v-model="CheckoutRequest.DataModel.Data.Capital.ReferenceNo">
                    <option style="padding:50px"
                      v-for="Dropdown in CheckoutRequest.Masters.CapitalList"
                      :value="Dropdown"
                      :key="Dropdown.ReferenceNo"
                    >{{ Dropdown.ReferenceNo }}</option>
                  </select>
                  <!-- </d-col> -->
                </d-col>

              </d-form-row>

              <d-form-row>
                <!-- Email -->
                <d-col md="6" class="form-group">
                  <label for="feEmail">Date</label>
                  <br />
                  <label style="font-weight:600">{{CheckoutRequest.DataModel.Data.Capital.Date}}</label>
                </d-col>

                <!-- Password -->
                <d-col md="6" class="form-group">
                  <label for="feEmail">Amount</label>
                  <br />
                  <label style="font-weight:600">{{CheckoutRequest.DataModel.Data.Capital.Amount}}</label>
                </d-col>
              </d-form-row>

              <!-- Address -->
              <div class="form-group">
                <label for="feEmail">Status</label>
                <br />
                <label style="font-weight:600">{{CheckoutRequest.DataModel.Data.Capital.Status.Name}}</label>

              </div>
              <d-button type="button" id="submit" :disabled="CheckoutRequest.DataModel.Data.Capital.Status.Name=='In Grace Period'" @click="SubmitCheckoutRequest" class="btn-accent">Submit</d-button>
            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "CheckoutRequest",
  data() {
    return {
      CheckoutRequest: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
          CustomerId: "1",
            Capital: {
              Id: 0,
              Date: null,
              ReferenceNo:null,
              CheckoutType: null,
              CheckoutAmount: null,
              ReasonforCheckout: null,
              CheckoutDate: null,
              Status: {
                Name: null
              },
              CustomerId: null,
              CompanyId: null,
              CreatedBy: 1
            }
          },
          UIData: {}
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0
          }
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: ""
          }
        ],
        Masters: {
          CapitalList: []
        },
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {
    this.ListCheckoutRequest();
    this.ListCapital();
  },
  methods: {

    Select(){
      console.log(this.CheckoutRequest.DataModel.Data.Capital);
    },
    ListCheckoutRequest() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.CheckoutRequest.DataModel.Data.Token = Token;
      this.CheckoutRequest.DataModel.Data.CRUD = "Create";
      var dataString = JSON.stringify(this.CheckoutRequest.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/CheckoutRequest/CheckoutRequest.php",
          dataString
        )
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            return response;
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
           this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    },


     SubmitCheckoutRequest() {
      let vm = this;
      if (
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.CheckoutRequest.DataModel.Data.Capital.ReferenceNo
        )


      ) {
        this.CheckoutRequest.DataModel.Data.CRUD = "Create";

        var dataString = JSON.stringify(this.CheckoutRequest.DataModel.Data);
        axios
          .post("APIScript/PHP/APIService/CheckoutRequest/CheckoutRequest.php", dataString)
          .then(function(response) {
            if (response.data.ErrorInfo == null) {
              console.log(response.data);
              // Vue.$toast.success("Save Successfully");
            } else {
              if (
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.CheckoutRequest.DataModel.Data.Capital.ReferenceNo
                )

              ) {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Information missing",
                  "Please provid Capital Number",
                  "error"
                );
              } else {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Oops...",
                  "Incorrect Capital Number !",
                  "error"
                );
              }
            }
          })
          .catch(function(response) {
            console.log(response);
            vm.$swal.fire("Oops", "Something went worng", "error");
          });
      } else {
        vm.$swal.fire(
          "Information missing",
          "Please provid Capital Number",
          "error"
        );
      }
    },

   ListCapital() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.CheckoutRequest.DataModel.Data.Token = Token;
      this.CheckoutRequest.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.CheckoutRequest.DataModel.Data);
      console.log(this.CheckoutRequest.DataModel.Data);
      axios
        .post("APIScript/PHP/APIService/Capital/Capital.php", dataString)
        .then(function(response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.CheckoutRequest.Masters.CapitalList = response.data.Result;

          // vm.CheckoutReques.Masters.CapitalList.map(function(value,key){

          //     value.Amount = Utilities.TransactionCurrencyFormat(value.Amount);

          // });
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            router.push("/Login");
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    }
  }
};
</script>
